import type { OEmbedInfo } from '@prezly/story-content-format';

function getThumbnailWidth(layout: 'vertical' | 'horizontal', isMobile: boolean) {
    if (layout === 'vertical') {
        return isMobile ? 400 : 800;
    }

    return 200;
}

function getThumbnailHeight(layout: 'vertical' | 'horizontal', isMobile: boolean) {
    if (layout === 'vertical') {
        return isMobile ? 250 : 500;
    }

    return 200;
}

function recropUploadcareImage(url: string, width: number, height: number) {
    return url.replace(/\/-\/scale_crop\/(\d+)x(\d+)\//, `/-/scale_crop/${width}x${height}/smart/`);
}

export function optimizeOembedThumbnail(
    oembed: OEmbedInfo,
    layout: 'vertical' | 'horizontal',
    isMobile: boolean,
): OEmbedInfo {
    if (!oembed.thumbnail_url) {
        return oembed;
    }

    const newWidth = getThumbnailWidth(layout, isMobile);
    const newHeight = getThumbnailHeight(layout, isMobile);

    return {
        ...oembed,
        thumbnail_url: recropUploadcareImage(oembed.thumbnail_url, newWidth, newHeight),
        thumbnail_width: newWidth,
        thumbnail_height: newHeight,
    };
}
